<template>
  <div>
    <div class="text-end">
      <router-link to="/mylibrary/bookmarks/management" class="btn btn-primary mb-2">{{
        $t("mylibrary.bookmarks.foldermanagement")
      }}</router-link>
    </div>
    <div class="popup_content bookmark_list_wrap">
      <div class="bookmark_inner">
        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            id="dropdownBookmark"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ bookmarkFolder }}
          </button>
          <ul
            v-if="folders.length > 0"
            class="dropdown-menu"
            aria-labelledby="dropdownBookmark"
          >
            <li v-for="(folder, index) in folders" :key="index" class="folder-img">
              <a
                class="dropdown-item"
                href="#"
                @click="showBookmarks(folder.folderId, folder.folderName)"
                >{{ folder.folderName }}</a
              >
            </li>
          </ul>
          <ul v-else class="dropdown-menu" aria-labelledby="dropdownBookmark">
            <li>
              <a class="dropdown-item" href="#">{{ $t("common.noData") }}</a>
            </li>
          </ul>
        </div>
        <div class="my_bookmark_box" v-if="active == true">
          <ul v-for="(bookmark, index) in items" :key="index">
            <li>
              <a target="_blank" :href="bookmark.linkId" class="bookmark_sub_title">
                {{ bookmark.bookmarkName }}
                <em>{{ bookmark.modelName }} | {{ bookmark.partNo }}</em>
              </a>
              <a href="#" @click="deleteBookmark(bookmark)" class="list_del">Delete</a>
            </li>
          </ul>
          <div v-if="items.length != 0" class="paging_nav">
            <div class="paging_nav">
              <a
                href="#"
                v-if="pagingVO.startPage <= pagingVO.blockSize"
                class="page_select prev_page disabled"
                >이전페이지 이동</a
              >
              <a
                v-else
                class="page_select prev_page"
                @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
                v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
                >이전페이지 이동</a
              >
              <span
                v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
                :key="index"
              >
                <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                  pagingVO.startPage + index
                }}</strong>
                <a href="#" v-else @click="searchPage(pagingVO.startPage + index)">{{
                  pagingVO.startPage + index
                }}</a>
              </span>
              <a
                v-if="pagingVO.endPage >= pagingVO.totalPage"
                href="#"
                class="page_select next_page disabled"
                >다음페이지 이동</a
              >
              <a
                v-else
                href="#"
                @click="searchPage(pagingVO.endPage + 1)"
                v-bind:data-page="pagingVO.endPage + 1"
                class="page_select next_page"
                >다음페이지 이동</a
              >
            </div>
          </div>
          <div v-else class="paging_nav">
            <div class="paging_nav">
              <a href="#" class="page_select prev_page disabled">이전페이지 이동</a>
              <span>
                <strong>1</strong>
              </span>
              <a href="#" class="page_select next_page disabled">다음페이지 이동</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bookmarkList, deleteBookmark, getBookmarks } from "@/api/bookmark";

export default {
  data() {
    return {
      bookmarks: "",
      folders: "",
      folderId: "",
      pagingVO: "",
      form: { page: 1, folderId: "" },
      bookmarkFolder: this.$t("mylibrary.bookmarks.bookmarkFolder"),
      items: "",
      active: false,
      component: null,
      componentName: null,
      deleteYN: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await bookmarkList();
        this.bookmarks = response.data.bookmarkList;
        this.folders = response.data.folderList;
        // 첫번째 폴더 기본값 클릭
        if (this.folders.length > 0) {
          this.showBookmarks(this.folders[0].folderId, this.folders[0].folderName);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async showBookmarks(folderId, folderName) {
      this.form.page = 1;
      this.active = true;
      this.folderId = folderId;
      this.bookmarkFolder = folderName;
      this.getBookmarks(folderId);
    },
    async getBookmarks(folderId) {
      try {
        this.form.folderId = folderId;
        const { data } = await getBookmarks(this.form);
        this.pagingVO = data.pagingVO;
        this.items = data.pagingVO.dataList;
      } catch (err) {
        console.log(err);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.getBookmarks(this.form.folderId);
    },
    async deleteBookmark(bookmark) {
      this.deleteYN = confirm(this.$t("alert.delete"));
      if (this.deleteYN) {
        try {
          const { data } = await deleteBookmark(bookmark);
          if (data.status) {
            this.fetchData();
            alert(this.$t("alert.deletedSuccessfully"));
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
